var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m14.172 2.01 7.197 7.197L9.497 21.079H2.3v-7.197L14.172 2.01Zm0 1.98-2.734 2.734 5.217 5.217 2.734-2.734-5.217-5.217Zm1.493 8.941-5.217-5.217L3.7 14.462v5.217h5.217l6.748-6.748ZM21 21.079h-8.69v-1.4H21v1.4Z"
})));
export { SvgPencil as ReactComponent };
export default __webpack_public_path__ + "1539523a273bbad2cd7630d8f7bded65.svg";